import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.0001 5C9.46492 5.00002 6.88193 6.09969 4.72845 8.38942C4.35008 8.79173 3.71721 8.81113 3.3149 8.43276C2.91259 8.05439 2.89318 7.42152 3.27156 7.01921C5.76324 4.36989 8.85771 3.00002 12 3C15.1423 2.99998 18.2368 4.36978 20.7284 7.01902C21.1068 7.42133 21.0874 8.05419 20.6851 8.43257C20.2828 8.81095 19.6499 8.79155 19.2716 8.38924C17.1181 6.0996 14.5352 4.99998 12.0001 5ZM3.3149 12.2097C3.71721 11.8313 4.35007 11.8507 4.72845 12.253C6.88191 14.5427 9.46488 15.6423 12 15.6423C14.5351 15.6423 17.1181 14.5427 19.2716 12.253C19.6499 11.8507 20.2828 11.8313 20.6851 12.2097C21.0874 12.588 21.1068 13.2209 20.7284 13.6232C19.5458 14.8807 18.2273 15.8499 16.8324 16.5212L17.8559 18.2148C18.1416 18.6875 17.9899 19.3023 17.5173 19.5879C17.0446 19.8736 16.4299 19.722 16.1442 19.2493L14.9297 17.2397C14.2944 17.4166 13.6495 17.5357 13 17.596V20C13 20.5523 12.5523 21 12 21C11.4478 21 11 20.5523 11 20V17.596C10.3506 17.5357 9.70567 17.4166 9.07037 17.2397L7.8559 19.2493C7.57024 19.722 6.9555 19.8736 6.48283 19.5879C6.01015 19.3023 5.85854 18.6875 6.1442 18.2148L7.16769 16.5213C5.77274 15.85 4.45424 14.8807 3.27156 13.6232C2.89319 13.2209 2.91259 12.588 3.3149 12.2097Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }